import React from "react";
import { useHistory } from "react-router-dom";

import LoginBannerNew from "../../../images/graph-login.png";
import LogoBlue from "../../../images/logo-blue.png";
import loginBanner from "../../../images/login-banner.png";
import { useStyles } from "./styles";

import Hidden from "@material-ui/core/Hidden";

const LoginWrapper = ({ children, type }) => {
  const classes = useStyles({ type });
  let history = useHistory();

  const handleLogoClick = () => {
    localStorage.removeItem("signin_email");
    history.push("/login");
  };

  return (
    <div className={classes.loginMain}>
      <Hidden xsDown>
        <div
          className={`${
            type === "login"
              ? "max-w-[1100px] h-[calc(100vh-50px)]"
              : "max-w-[508px] h-full"
          }  mx-auto my-0 flex flex-col justify-center`}
        >
          <div className={classes.loginWrapperPaper}>
            {type === "login" && (
              <div className="h-full lg:grid grid-cols-5 shadow-lg">
                <div
                  style={{ backgroundImage: `url(${loginBanner})` }}
                  className="hidden lg:flex bg-cover bg-no-repeat bg-center col-span-3 p-14 flex-col items-start"
                >
                  <div className="text-5xl max-w-[400px]">
                    Ready for a Life-Changing Journey?
                  </div>
                  <div className="text-lg leading-6 mt-4  text-[#0D1C3A99]">
                    Join a community of Spiking Premium members who benefit from
                    our exclusive market insights and advanced trading tools.
                  </div>
                </div>
                <div className="px-9 py-9 relative h-full col-span-2 bg-white">
                  <img
                    src={LogoBlue}
                    height="36px"
                    width="83.45px"
                    alt="spiking logo blue"
                    className="my-0 mx-auto mb-4 cursor-pointer"
                    onClick={handleLogoClick}
                  />
                  {children}
                </div>
              </div>
            )}
            {type === "forgotPassword" && (
              <div>
                <img
                  src={LogoBlue}
                  height="36px"
                  width="83.45px"
                  alt="spiking logo blue"
                  className="my-0 mx-auto mb-4 cursor-pointer"
                  onClick={handleLogoClick}
                />
                {children}
              </div>
            )}
          </div>
        </div>
        {/* </div> */}
      </Hidden>
      <Hidden smUp>
        <div
          // className="p-6 pt-12 h-full"
          className={classes.loginWrapperPaperMobile}
        >
          <div>
            <img
              src={LogoBlue}
              height="36px"
              width="83.45px"
              alt="spiking logo blue"
              className="my-0 mx-auto mb-4 cursor-pointer"
              onClick={handleLogoClick}
            />
            {children}
          </div>
        </div>
      </Hidden>
    </div>
  );
};

export default LoginWrapper;
